import {adbApi} from "./adbService";

export const quarterlyApi = adbApi.injectEndpoints({
    endpoints: (builder) => ({

        //   Quarterly Reports Page
        getQuarterlyReportPage: builder.query({
            query: () => ({
                url: "pages/quarterly-report/list",
                method: "GET",
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        getQuarterlyReportEditPage: builder.query({
            query: () => ({
                url: "pages/quarterly-report/edit",
                method: "GET",
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        getQuarterlyReportPhotographs: builder.query({
            query: () => ({
                url: "pages/quarterly-report/edit",
                method: "GET",
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),  //not used

        // Site Photographs
        getQuarterlyPhotographs: builder.query({
            query: (reportId) => ({
                url: `quarterly-report/site-photographs/list/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["QuarterlyPhotographs"],
        }),
        createPhoto: builder.mutation({
            query: (body) => ({
                url: 'quarterly-report/site-photographs/create',
                method: "POST",
                body
            }),
            invalidatesTags: ["QuarterlyPhotographs"],
        }),
        updateSitePhotograph: builder.mutation({
            query: ({id, body}) => ({
                url: `quarterly-report/site-photographs/update/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["QuarterlyPhotographs"],
        }), //not used
        deleteSitePhotographs: builder.mutation({
            query: ( id) => ({
                url: `quarterly-report/site-photographs/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["QuarterlyPhotographs"],
        }),


        getQuarterlyReportDetailsPage: builder.query({
            query: () => ({
                url: "pages/quarterly-report/details",
                method: "GET",
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),

        //   Quarterly Report Section List
        getAllQuarterlyReports: builder.query({
            query: () => ({
                url: "quarterly-report",
                method: "GET",
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        getQuarterlyReportSections: builder.query({
            query: () => ({
                url: "quarterly-report/sections",
                method: "GET",
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        getQuarterlyReportProjects: builder.query({
            query: () => ({
                url: "quarterly-report/projects",
                method: "GET",
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        getQuarterlyReportInfo: builder.query({
            query: (quarterly_report_id) => ({
                url: `quarterly-report/info/${quarterly_report_id}`,
                method: "GET",
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        createQuarterlyReport: builder.mutation({
            query: (body) => ({
                url: 'quarterly-report',
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        updateQuarterlyReport: builder.mutation({
            query: ({body, quarterlyReportId}) => ({
                url: `quarterly-report/${quarterlyReportId}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        deleteQuarterlyReport: builder.mutation({
            query: (quarterlyReportId) => ({
                url: `quarterly-report/${quarterlyReportId}`,
                method: "DELETE",
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        updateQuarterlyReportCover: builder.mutation({
            query: ({body, reportId}) => ({
                url: `quarterly-report/report-cover/${reportId}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        deleteQuarterlyReportCover: builder.mutation({
            query: ( reportId) => ({
                url: `quarterly-report/report-cover/${reportId}`,
                method: "DELETE",
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        getQuarterlyReportDetails: builder.query({
            query: (reportId) => ({
                url: `quarterly-report/details/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        submitQuarterlyReport: builder.mutation({
            query: ( reportId) => ({
                url: `quarterly-report/submit/${reportId}`,
                method: "POST",
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),

        duplicateQuarterlyReport: builder.mutation({
            query: ({reportId, body}) => ({
                url: `quarterly-report/duplicate/${reportId}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["QuarterlyReport"],
        }),
        // Financing Plan
        getFinancingPlanSources: builder.query({
            query: () => ({
                url: 'quarterly-report/financing-plan/sources',
                method: "GET",
            }),
            invalidatesTags: ["FinancingPlan"],
        }),
        getFinancingPlan: builder.query({
            query: (reportId) => ({
                url: `quarterly-report/financing-plan/list/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["FinancingPlan"],
        }),
        createFinancingPlan: builder.mutation({
            query: (body) => ({
                url: 'quarterly-report/financing-plan/create',
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["FinancingPlan"],
        }),
        updateFinancingPlan: builder.mutation({
            query: ({id, body}) => ({
                url: `quarterly-report/financing-plan/update/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["FinancingPlan"],
        }),
        deleteFinancingPlan: builder.mutation({
            query: ( id) => ({
                url: `quarterly-report/financing-plan/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["FinancingPlan"],
        }),
        // Loan Utilization
        getLoanUtilization: builder.query({
            query: (reportId) => ({
                url: `quarterly-report/loan-utilization/list/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["LoanUtilization"],
        }),
        updateLoanUtilization: builder.mutation({
            query: ({id, body}) => ({
                url: `quarterly-report/loan-utilization/update/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["LoanUtilization"],
        }),
        // Project Contract Award
        getProjectContractAward: builder.query({
            query: (reportId) => ({
                url: `quarterly-report/project-contract-award/list/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["ProjectContractAward"],
        }),
        updateProjectContractAward: builder.mutation({
            query: ({id, body}) => ({
                url: `quarterly-report/project-contract-award/update/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["ProjectContractAward"],
        }),
        // DevelopmentObjectives
        getDevObjectives: builder.query({
            query: (reportId) => ({
                url: `quarterly-report/development-objectives/details/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["DevelopmentObjectives"],
        }),
        updateDevObjectives: builder.mutation({
            query: ({id, body}) => ({
                url: `quarterly-report/development-objectives/update/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["DevelopmentObjectives"],
        }),

        // Implementation Progress
        getImplementationProg: builder.query({
            query: (reportId) => ({
                url: `quarterly-report/implementation-progress/details/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["ImplementationProgress"],
        }),
        updateImplementationProg: builder.mutation({
            query: ({id, body}) => ({
                url: `quarterly-report/implementation-progress/update/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["ImplementationProgress"],
        }),
        getProgressPerOutputs: builder.query({
            query: (reportId) => ({
                url: `quarterly-report/progress-per-outputs/list/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["ImplementationProgress"],
        }),
        createProgressPerOutputs: builder.mutation({
            query: (body) => ({
                url: 'quarterly-report/progress-per-outputs/create',
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["ImplementationProgress"],
        }),
        updateProgressPerOutputs: builder.mutation({
            query: ({id, body}) => ({
                url: `quarterly-report/progress-per-outputs/update/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["ImplementationProgress"],
        }),
        deleteProgressPerOutputs: builder.mutation({
            query: ( id) => ({
                url: `quarterly-report/progress-per-outputs/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["ImplementationProgress"],
        }),
        getMajorProblemsWithIp: builder.query({
            query: ({reportId, url}) => ({
                url: `quarterly-report/${url}/list/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["ImplementationProgress"],
        }),
        createMajorProblemsWithIp: builder.mutation({
            query: ({body, url}) => ({
                url: `quarterly-report/${url}/create`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["ImplementationProgress"],
        }),
        updateMajorProblemsWithIp: builder.mutation({
            query: ({id, body, url}) => ({
                url: `quarterly-report/${url}/update/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["ImplementationProgress"],
        }),
        deleteMajorProblemsWithIp: builder.mutation({
            query: ({id, url}) => ({
                url: `quarterly-report/${url}/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["ImplementationProgress"],
        }),
        // Covenants
        // Financial Covenants

        getFinancialCovenants: builder.query({
            query: (reportId) => ({
                url: `quarterly-report/covenants/financial-covenants/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["FinancialCovenants"],
        }),
        updateFinancialCovenants: builder.mutation({
            query: ({id, body}) => ({
                url: `quarterly-report/covenants/financial-covenants/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["FinancialCovenants"],
        }),
        getSubmissionsAudited: builder.query({
            query: ({reportId, url}) => ({
                url: `${url}/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["FinancialCovenants"],
        }),
        updateSubmissionsAudited: builder.mutation({
            query: ({id, body, url}) => ({
                url: `${url}/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["FinancialCovenants"],
        }),

        // Ratios
        getFinancialRatios: builder.query({
            query: (reportId) => ({
                url: `quarterly-report/covenants/financial-ratios/list/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["FinancialCovenants"],
        }),
        createFinancialRatios: builder.mutation({
            query: (body) => ({
                url: 'quarterly-report/covenants/financial-ratios/create',
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["FinancialCovenants"],
        }),
        updateFinancialRatios: builder.mutation({
            query: ({id, body}) => ({
                url: `quarterly-report/covenants/financial-ratios/update/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["FinancialCovenants"],
        }),
        deleteFinancialRatios: builder.mutation({
            query: ( id) => ({
                url: `quarterly-report/covenants/financial-ratios/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["FinancialCovenants"],
        }),
        // Sub Ratios
        getFinancialSubRatios: builder.query({
            query: (financialReportId) => ({
                url: `quarterly-report/covenants/financial-ratios/ratios/list/${financialReportId}`,
                method: "GET",
            }),
            invalidatesTags: ["FinancialCovenants"],
        }),
        createFinancialSubRatios: builder.mutation({
            query: (body) => ({
                url: 'quarterly-report/covenants/financial-ratios/ratios/create',
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["FinancialCovenants"],
        }),
        updateFinancialSubRatios: builder.mutation({
            query: ({id, body}) => ({
                url: `quarterly-report/covenants/financial-ratios/ratios/update/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["FinancialCovenants"],
        }),
        deleteFinancialSubRatios: builder.mutation({
            query: ( id) => ({
                url: `quarterly-report/covenants/financial-ratios/ratios/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["FinancialCovenants"],
        }),

        // Covenants
        getCovenants: builder.query({
            query: ({reportId, type}) => ({
                url: `quarterly-report/covenants/covenant/list/${reportId}?type=${type}`,
                method: "GET",
            }),
            invalidatesTags: ["Covenants"],
        }),
        createCovenants: builder.mutation({
            query: (body) => ({
                url: 'quarterly-report/covenants/covenant/create',
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["Covenants"],
        }),
        updateCovenants: builder.mutation({
            query: ({id, body}) => ({
                url: `quarterly-report/covenants/covenant/update/${id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["Covenants"],
        }),
        deleteCovenants: builder.mutation({
            query: ( id) => ({
                url: `quarterly-report/covenants/covenant/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Covenants"],
        }),
        // Site Documents
        getQRDocuments: builder.query({
            query: (reportId) => ({
                url: `quarterly-report/document/list/${reportId}`,
                method: "GET",
            }),
            invalidatesTags: ["QuarterlyDocument"],
        }),
        downloadQRDocuments: builder.query({
            query: (id) => ({
                url: `/quarterly-report/document/download/${id}`,
                method: "GET",
            }),
            invalidatesTags: ["QuarterlyDocument"],
        }),

    }),
    overrideExisting: false,
});

export const {
    //   Quarterly Reporting
    useGetQuarterlyReportPageQuery,
    useGetQuarterlyReportEditPageQuery,
    useCreatePhotoMutation,
    useDeleteSitePhotographsMutation,
    useLazyGetQuarterlyPhotographsQuery,
    useLazyGetQuarterlyReportDetailsPageQuery,
    useLazyGetQuarterlyReportSectionsQuery,
    // Create Report step 2 projects
    useLazyGetQuarterlyReportProjectsQuery,
    useLazyGetAllQuarterlyReportsQuery,
    useLazyGetQuarterlyReportInfoQuery,
    useCreateQuarterlyReportMutation,
    useUpdateQuarterlyReportMutation,
    useDeleteQuarterlyReportMutation,
    useUpdateQuarterlyReportCoverMutation,
    useDeleteQuarterlyReportCoverMutation,
    useLazyGetQuarterlyReportDetailsQuery,
    useSubmitQuarterlyReportMutation,
    useDuplicateQuarterlyReportMutation,
    //   Financing Plan
    useLazyGetFinancingPlanSourcesQuery,
    useLazyGetFinancingPlanQuery,
    useCreateFinancingPlanMutation,
    useUpdateFinancingPlanMutation,
    useDeleteFinancingPlanMutation,
    // Laon Utilization
    useLazyGetLoanUtilizationQuery,
    useUpdateLoanUtilizationMutation,
    //   ProjectContractAward
    useLazyGetProjectContractAwardQuery,
    useUpdateProjectContractAwardMutation,
    // Development Objectives
    useLazyGetDevObjectivesQuery,
    useUpdateDevObjectivesMutation,
    //   Implementation Progress
    useLazyGetImplementationProgQuery,
    useUpdateImplementationProgMutation,
    useLazyGetProgressPerOutputsQuery,
    useCreateProgressPerOutputsMutation,
    useUpdateProgressPerOutputsMutation,
    useDeleteProgressPerOutputsMutation,
    useLazyGetMajorProblemsWithIpQuery,
    useCreateMajorProblemsWithIpMutation,
    useUpdateMajorProblemsWithIpMutation,
    useDeleteMajorProblemsWithIpMutation,
    // financial ratios
    useLazyGetFinancialRatiosQuery,
    useCreateFinancialRatiosMutation,
    useCreateFinancialSubRatiosMutation,
    useDeleteFinancialRatiosMutation,
    useDeleteFinancialSubRatiosMutation,

    useLazyGetFinancialCovenantsQuery,
    useUpdateFinancialCovenantsMutation,
    useLazyGetSubmissionsAuditedQuery,
    useUpdateSubmissionsAuditedMutation,
    //   Other Covenants
    useLazyGetCovenantsQuery,
    useUpdateCovenantsMutation,
    useCreateCovenantsMutation,
    useDeleteCovenantsMutation,

    //   Documents
    useLazyGetQRDocumentsQuery,
    //   Progress tables

} = quarterlyApi;
